import React, { useState }  from "react";
import InputField from "components/fields/InputField";
import Button from "components/button";
import { connect } from "react-redux";
import { doForgotPassword } from "../../redux/auth/authState";
import { Alert, Card, message } from 'antd';
import ApplicationName from "components/app-name";
import { ArrowRight, Lock, Mail, Shield } from "lucide-react";
import { RELEASE_VERSION } from '../../constants';

const ForgotPassword = ({ successMsg, forgotPassword, loading, error }) => {
  const [inputs, setInputs] = useState({});
  const [validation, setValidation] = useState(null);
  
  const handleChange = (event) => {
    const name = event.target.id;
    const value = event.target.value;
    setInputs(values => ({...values, [name]: value}));
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    let validatioError = null;
    
    try {   

      if(!inputs.username){
        validatioError = "Username is required.";
        message.error(validatioError);
        return;
      }
      
      setValidation(validatioError);

      forgotPassword(inputs);
    } catch (error) {
      console.error('Forgot password failed:', error);
    }
  };

  return (
    <div className="mt-4 flex items-center justify-center h-full">
      
      <div className="relative max-w-[440px] w-full items-center justify-center  md:mx-0 md:px-0 lg:mb-10" >
        
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute -top-3 -left-3 w-10 h-10 border-t border-l border-slate-100/60"></div>
            <div className="absolute -top-3 -right-3 w-10 h-10 border-t border-r border-slate-100/60"></div>
            <div className="absolute -bottom-3 -left-3 w-10 h-10 border-b border-l border-slate-100/60"></div>
            <div className="absolute -bottom-3 -right-3 w-10 h-10 border-b border-r border-slate-100/60"></div>
          </div>

        <Card 
        style={{ clipPath: 'polygon(0 0, 100% 0, 100% 97%, 96% 100%, 0 100%)' }}
        className="w-[440px] rounded-none border-none dark:bg-intsamis-800">

          <div className="flex flex-col items-center justify-center mb-6">
              <ApplicationName
                extra="flex justify-center items-center mb-4 w-[200px] ps-6 dark:text-white"
                logoClass="logo-xs"
              />

            <h1 className="text-[26px] sm:text-[28px] font-medium dark:text-white">
                Forgot Password
            </h1>
            
          </div>
        
          <div className="mt-6 h-px w-20 mx-auto bg-gradient-to-r from-white via-slate-300 to-white dark:from-intsamis-800 dark:via-white dark:to-intsamis-800"></div>

          <form onSubmit={handleSubmit}>
            <div className="pt-2 h-full w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
            
              <InputField
                variant="auth"
                extra="mb-3"
                icon={<Mail className="w-3.5 h-3.5 text-gray-500"/>}
                label="Username"
                placeholder="Enter your username"
                id="username"
                value={inputs.username}
                onChange={handleChange}
              />

              {error &&
              <div className="min-h-[18px] my-3">
                 <Alert className="p-3 text-red-700" message={error} type="error" showIcon /> 
              </div>  
              }

              {validation &&
              <div className="min-h-[18px] my-3">
                 <Alert className="p-3 text-red-700" message={validation} type="error" showIcon /> 
              </div>  
              }

              {successMsg && 
              <div className="min-h-[18px] my-3">
                 <Alert className="p-3" message={successMsg} type="success" showIcon /> 
              </div> 
              }

              <div className="w-full flex gap-4">
              <a
                className="btn btn-primary w-full h-12 bg-gradient-to-r from-violet-600 via-blue-600 to-cyan-600 
                            hover:from-violet-500 hover:via-blue-500 hover:to-cyan-500 text-white 
                            relative overflow-hidden group transition-all duration-300 flex items-center gap-2"
                href="/auth/sign-in"
              >
                Cancel
              </a>
              <Button type="submit" 
                      extra={`w-full h-12 bg-gradient-to-r from-violet-600 via-blue-600 to-cyan-600 
                              hover:from-violet-500 hover:via-blue-500 hover:to-cyan-500 text-white 
                              relative overflow-hidden group transition-all duration-300 flex items-center gap-2
                              w-full ${loading && 'disabled'}`} disabled={loading}
              >
                Reset Password <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform duration-300"/>
              </Button>
              </div>
              
              <div className="relative my-6">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-slate-200"></div>
                  </div><div className="relative flex justify-center text-[11px]">
                    <span className="bg-white px-4 text-slate-400  dark:bg-intsamis-800" >
                      Secured by 256-bit encryption
                    </span>
                  </div>
                </div>
              </div>

              <div className="space-y-3">
                <div className="flex items-center justify-center gap-4 text-[11px] text-slate-500 flex-wrap">
                  <div className="flex items-center gap-1.5">
                    <Shield className="w-3.5 h-3.5 text-emerald-600"/>
                    <span>SSL Protected</span>
                  </div>
                  <div className="w-1 h-1 bg-slate-300 rounded-full"></div>
                  <div className="flex items-center gap-1.5">
                    <Lock className="w-3.5 h-3.5 text-cyan-600"/>
                    <span>End-to-end Encrypted</span>
                  </div>
                </div>
              </div>
          </form>
        </Card>
        <div className="mt-5 text-center text-[11px] text-slate-400/60 space-y-1">
          <div>HyvidOne Enterprise Platform {RELEASE_VERSION}</div>
          <div className="flex items-center justify-center gap-2 flex-wrap text-[10px]">
            <span>©{1900 + new Date().getYear()} Hyvid Pty Ltd</span>
            <span>•</span>
            <span>Designed by Mediaverse Digital Collective; Developed by Intsamis</span>
          </div>
        </div>
      </div>
    </div>

  );
}

const mapStateToProps = (state) => ({
  loading: state.auth.loading,
  error: state.auth.error,
  successMsg: state.auth.forgotPasswordMsg,
});

const mapDispatchToProps = (dispatch) => ({
  forgotPassword: (data) => dispatch(doForgotPassword(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
